import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Container from '../partials/Container'
import PostEditor from '../partials/PostEditor'

import styleB from '../style'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Blog', 'Config')
@observer
export class CreatePost extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: true,
        title: '',
        content: ''
      }
    }
  }

  onSaveClick (e) {
    e.preventDefault()

    const post = {
      title: this.state.editor.title,
      content: this.state.editor.content
    }

    return this.props.Blog.postPost(post).then(_post => {
      this.props.history.push(`/dashboard/news/${_post.seo}`)
    })
  }

  onTitleChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        title: e.target.value
      }
    })
  }

  onContentChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        content: e
      }
    })
  }

  onInputFocus (type, e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: true,
        field: type
      }
    })
  }

  onInputBlur (type, e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: false,
        field: null
      }
    })
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <h2 className={css(styleB.headers.h2)}>Create New</h2>
          </Col>
          <Col>
            <Row>
              <Col />
              <Col>
                <span
                  onClick={this.onSaveClick.bind(this)}
                  className={css(styleB.buttons.button, styleB.buttons.red)}
                >
                  Save
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <PostEditor
              onTitleChange={this.onTitleChange.bind(this)}
              onContentChange={this.onContentChange.bind(this)}
              onContentFocus={this.onInputFocus.bind(this, 'content')}
              onContentBlur={this.onInputBlur.bind(this, 'content')}
              editor={this.state.editor}
              theme={THEME_LIST[this.props.Config.theme]}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CreatePost



// WEBPACK FOOTER //
// ./src/components/News/Create/index.js